import { makeStyles } from '@material-ui/core/styles';
import { drawerWidth, drawerCloseWidth } from '~/config/layout';

export default makeStyles(theme => ({
  drawer: {
    flexShrink: 0,
    height: '100vh',
    position: 'fixed',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    paddingRight: 10,
    paddingLeft: 10,
    backgroundImage: `linear-gradient(to bottom right, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: drawerCloseWidth,
  },
  divider: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.28)',
  }
}));
